import { createStore } from 'redux'

const isMobile = typeof window !== 'undefined' && window.innerWidth < 768

const initialState = {
  sidebarShow: !isMobile,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
